module.exports = __webpack_public_path__ + "static/ama-krushai-launch-dc075e4849f979b5fab0ad90b2158f1a.png";